module.exports = __webpack_public_path__ + "img/Kanhu_Mallik.89bb1b19.jpg";